// Shared formatters and color tokens used across the player Overview tab
// (PlayerProfilePage.js and MetricsWindow.js) — extracted so neither file
// needs to import from the other.

export const METRIC_COLORS = {
  positive: '#00BD71',
  negative: '#E21351',
  gold:     '#d4a843',
  warning:  '#FFD22F',
};

// Slightly lighter than METRIC_COLORS.positive/negative — matches the existing
// TrendBadge delta-arrow shades exactly, reused here for range-mode deltas.
export const DELTA_COLORS = {
  up:   '#00c896',
  down: '#e05555',
};

export const fmtEur = (n) => {
  if (n == null) return '—';
  const a = Math.abs(n);
  if (a >= 1_000_000) return (n / 1_000_000).toFixed(1) + 'M€';
  if (a >= 1_000) return Math.round(n / 1_000) + 'K€';
  return Math.round(n) + '€';
};

export const fmtPct = (v) => (v == null ? '—' : v.toFixed(1) + '%');

export function fmtMin(m) {
  if (m == null) return '—';
  const h = Math.floor(m / 60);
  const min = Math.round(m % 60);
  return h > 0 ? `${h}h ${min}m` : `${min}m`;
}

export const fmtTime = (s) => {
  const m = Math.round((s || 0) / 60);
  if (m > 60) return `${Math.floor(m / 60)}h ${m % 60}m`;
  return m > 0 ? `${m}m` : '—';
};

export const fmtDateShort = (raw) => {
  if (!raw) return null;
  const d = raw instanceof Date ? raw : new Date(raw);
  if (isNaN(d)) return null;
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};
